// Port of api/fuel/app/classes/insights/plays/type.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'type',
    insight: false,
    default_: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''
        var typeFilter = filter.type || 'category'

        var table = (typeFilter === 'category') ? 'category' : 'mechanic'

        // Get the type name
        var typeRow = Util.queryFast(
            'SELECT ' + table + '_name FROM ' + table +
            ' WHERE ' + table + '_id = ' + vars.id
        )
        var typeName = typeRow.length ? typeRow[0][table + '_name'] : ''

        var games = []

        var ratings = Util.queryFast(
            'SELECT l.game_id AS g,' +
            ' AVG(r.rating_value) AS r,' +
            ' COUNT(DISTINCT r.rating_id) AS c,' +
            ' COUNT(DISTINCT p.play_id) AS p' +
            ' FROM game_' + table + ' l, play p, game g' +
            ' LEFT JOIN rating r ON r.game_id = g.game_id' +
            ' AND r.user_id IN(' + Util.in(userIndex) + ')' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date < ' + range.end +
            ' AND p.game_id = g.game_id' +
            ' AND l.game_id = g.game_id' +
            ' AND l.' + table + '_id = ' + vars.id +
            ' AND g.game_id = l.game_id' +
            ' AND g.game_type = 1' +
            sqlCount +
            ' GROUP BY l.' + table + '_id, l.game_id' +
            ' ORDER BY COUNT(DISTINCT p.play_id) DESC, g.game_name ASC' +
            ' LIMIT 0, 250'
        )

        for (var i = 0; i < ratings.length; i++) {
            var game = ratings[i]

            this._references.games.push(parseInt(game.g, 10))

            games.push({
                id: parseInt(game.g, 10),
                count: parseInt(game.c, 10),
                rating: game.r ? parseFloat(game.r) : '-',
                playsCount: parseInt(game.p, 10)
            })
        }

        return {
            type: typeName,
            games: games
        }

    }
})
